<template>
  <div 
    class="  px-10 mt-12">
    <v-layout wrap>
      <v-flex>
        <section>
          
          <div class="color-dark-blue fs-22 font-weight-bold">
            Tambahkan Penerimaan
          </div>

          <v-row
            class="">
            <v-col 
              cols="12"
              class="px-0">
              <v-card 
                flat
                style="background: transparent;">
                <v-card-text>
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <!-- <div
                        class="mb-4">
                        <div 
                          class="body-2 mb-2">
                          Poto Profil
                        </div>

                        <uploadfolder v-if="form.image_url === ''"
                          v-model="upload.image">
                          <div 
                            slot="activator">
                            <v-card 
                              flat
                              width="200"
                              height="200"
                              class="d-flex align-center justify-center cursor-pointer"
                              style="border-radius: 15px;
                                    border: 2px solid #EBEBEB; 
                                    border-style: dashed;">
                              <v-avatar v-if="!process.image"
                                v-ripple
                                tile 
                                width="200"
                                height="200">
                                <v-icon
                                  size="50"
                                  color="#B9B9B9">
                                  mdi-cloud-upload-outline
                                </v-icon>
                              </v-avatar>

                              <v-progress-circular v-else
                                indeterminate
                                :color="set_color">
                              </v-progress-circular>
                            </v-card>
                          </div>
                        </uploadfolder>

                        <v-card v-if="form.image_url !== ''"
                          flat
                          width="200"
                          height="200"
                          class="d-flex align-center justify-center"
                          style="border-radius: 15px;
                                border: 2px solid #EBEBEB; 
                                border-style: dashed;">
                          <v-avatar
                            v-ripple
                            tile 
                            size="200"
                            style="border-radius: 15px;">
                            <v-img 
                              contain
                              width="100%"
                              height="100%"
                              alt="Distributor Amanata" 
                              :src="form.image_url"
                              class="ma-auto"
                              style="border-radius: 15px;">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>

                          <v-icon 
                            @click="form.image_url = ''"
                            color="red"
                            class="cursor-pointer"
                            style="position: absolute; top: -10px; right: -10px;">
                            mdi-close-circle
                          </v-icon>
                        </v-card>
                      </div> -->

                      <v-row>
                        
                        <v-col
                          cols="12"
                          md="11" class="pt-0 pr-8">

                          <ValidationProvider
                            name="Pembelian" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              Pembelian
                            </div>
      
                            <v-autocomplete
                              v-on:keydown.enter.prevent="save()"
                              v-on:change="changePembelian()"
                              
                              filled
                              rounded
                              dense
                              solo
      
                              color="#4828a1"
                              placeholder="Pembelian"
      
                              
                              :items="pembelian"
                              item-value="id"
                              item-text="number"
                              :item-color="set_color"
      
                              v-model="form.po_id"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </ValidationProvider>



                          <ValidationProvider
                            name="Nomor Surat Jalan" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              Nomor Surat Jalan
                            </div>
      
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#4828a1"
                              placeholder="Nomor Surat Jalan"
        
                              
        
                              v-model="form.no_surat_jalan"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>

                          <div>
                            <div v-for="(item, index) in form.varian_arr" :key="index">
                          <v-card flat class="mb-5">
                            <v-card-text>
                              <div class="d-flex">
                                <div>
                                  <div class="fs-16 font-weight-bold label-input">
                                    {{ item.name }}
                                  </div>
                                  <div>
                                    <span>Kode SKU</span>: <span class="font-weight-bold label-input">{{ item.sku }}</span>
                                  </div>
                                  <div>
                                    <span>Qty PO</span>: <span class="font-weight-bold label-input">{{ item.qty_po | number }} {{ item.unit }}</span>
                                  </div>
                                  <!-- <div>
                                    <span>Jumlah Penerimaan qty diterima sebelumnya</span>: <span class="font-weight-bold label-input">{{ item.penerimaan_qty_terima }} {{ item.unit }}</span>
                                  </div> -->
                                  <div>
                                    <span>Total Qty yang sudah diterima</span>: <span class="font-weight-bold label-input">{{ item.penerimaan_qty_total | number }} {{ item.unit }}</span>
                                    <!-- <span v-if="item.unit !== 'pcs'" class="font-weight-bold label-input ml-2">( {{ item.unit === 'dus' ? `1 Dus = ${item.total_in_dus} pcs` : '1 Lusin = 12 pcs' }}, {{ item.unit === 'dus' ? `${item.penerimaan_qty_total} dus = ` : `${item.penerimaan_qty_total} lusin = ` }}
                                      <span v-if="item.unit === 'dus'">
                                        {{ (item.penerimaan_qty_total * 1 * item.total_in_dus) | price }}
                                      </span>
                                      <span v-else>
                                        {{ (item.penerimaan_qty_total * 1 * 12) | price }}
                                      </span>
                                     pcs )</span> -->
                                  </div>
                                  <!-- <div>
                                    <span>PPN</span>: <span class="font-weight-bold label-input">{{ item.ppn_beli*1 }}%</span>
                                  </div>
                                  <div>
                                    <span>Harga Beli</span>: <span class="font-weight-bold label-input">{{ item.harga_beli*1 | price }}</span>
                                  </div> -->
                                </div>
                                
                              </div>

                              <v-row>

                                <!-- <v-col>
                                  <div class="fs-15 label-input">
                                    Qty QC
                                  </div>

                                  
                                  <v-currency-field
                                        
                                    filled
                                    rounded
                                    dense
                                    solo
              
                                    color="#4828a1"
                                    placeholder="Qty"

                                    
              
                                    v-model="item.qty_qc"
                                    required
                                    style="border-radius: 10px;">
                                  </v-currency-field>
          
                                </v-col> -->
                                <v-col>
                                  <div class="fs-15 label-input">
                                    <!-- <span class="red--text">*</span> -->
                                    Qty Diterima
                                  </div>

                                  <ValidationProvider
                                    :name="`Qty Diterima ${item.name}`" 
                                    :rules="`min_value:0|max_value:${item.qty_po}`" 
                                    v-slot="{ errors }">
                                    <v-currency-field
                                          
                                      filled
                                      rounded
                                      dense
                                      solo
                
                                      color="#4828a1"
                                      placeholder="Qty"
                                      :error-messages="errors"
                                      :suffix="item.unit"

                                      
                
                                      v-model="item.qty"
                                      required
                                      style="border-radius: 10px;">
                                    </v-currency-field>
                                  </ValidationProvider>
          
                                </v-col>

                                <v-col>
                                  <div class="fs-15 label-input">
                                    <!-- <span class="red--text">*</span> -->
                                    Qty Extra
                                  </div>

                                  <ValidationProvider
                                    :name="`Qty Extra ${item.name}`" 
                                    rules="min_value:0" 
                                    v-slot="{ errors }">
                                    <v-currency-field
                                          
                                      filled
                                      rounded
                                      dense
                                      solo
                
                                      color="#4828a1"
                                      placeholder="Qty"
                                      :error-messages="errors"
                                      :suffix="item.unit"
                                      
                
                                      v-model="item.qty_extra"
                                      required
                                      style="border-radius: 10px;">
                                    </v-currency-field>
                                  </ValidationProvider>
          
                                </v-col>

                                <!-- <v-col>
                                  <div class="fs-15 label-input">
                                    PPN Beli
                                  </div>

                                  <div class="fs-18 label-input font-weight-bold">
                                    {{ item.ppn_beli | price }}
                                  </div>
          
                                </v-col> -->
                                <v-col>
                                  <div class="fs-15 label-input">
                                    <!-- <span class="red--text">*</span> -->
                                    Tanggal Expired
                                  </div>

                                  <div>
                                    <v-menu
                                      v-model="menu[index].menu"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="auto"
                                      >
                                      <template v-slot:activator="{ on, attrs }">
                                        <ValidationProvider 
                                          :name="`Tanggal Expired ${item.name}`" 
                                          rules="required" 
                                          v-slot="{ errors }">
                                          <v-text-field
                                            v-model="item.expired_date"
                                            
                                            v-on:keyup.enter="save()"
                                            
                                            filled
                                            solo
                                            rounded
                                            dense
                                            
                                            :color="set_color"
                                            placeholder="Tanggal Expired"
                      
                      
                                          
                      
                                            :error-messages="errors"
                                            required
                                            style="border-radius: 10px;"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            >
                                          </v-text-field>
                                        </ValidationProvider>
                                      </template>
                                      <v-date-picker
                                        v-model="item.expired_date"
                                        :min="new Date().toISOString().substr(0, 10)"
                                        @input="menu[index].menu = false"
                                      ></v-date-picker>
                                    </v-menu>
                                  </div>
          
                                </v-col>
                              </v-row>

                            </v-card-text>
                          </v-card>
                        </div>
                          </div>

                          <!-- <ValidationProvider
                            name="Nomor Penerimaan" 
                            rules="" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              Nomor Penerimaan
                            </div>
      
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#4828a1"
                              placeholder="Nomor Penerimaan"
        
                              
        
                              v-model="form.number"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider> -->


                          <!-- <ValidationProvider
                            name="Penerimaan Stok" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              Penerimaan Stok
                            </div>
      
                            <v-autocomplete
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
      
                              color="#4828a1"
                              placeholder="Penerimaan Stok"
      
                              
                              :items="category"
                              item-value="id"
                              item-text="title"
                              :item-color="set_color"
      
                              v-model="form.category"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </ValidationProvider> -->


                          <!-- <div class="fs-15 label-input">
                          
                            Tanggal
                          </div>
            
                          <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                            >
                            <template v-slot:activator="{ on, attrs }">
                              <ValidationProvider 
                                name="Tanggal" 
                                rules="required" 
                                v-slot="{ errors }">
                                <v-text-field
                                  v-model="form.date"
                                  
                                  v-on:keyup.enter="save()"
                                  
                                  filled
                                  solo
                                  rounded
                                  dense
                                  
                                  :color="set_color"
                                  placeholder="Tanggal"
            
                                  :disabled="Object.keys(form).length < 1"
            
                                
            
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  >
                                </v-text-field>
                              </ValidationProvider>
                            </template>
                            <v-date-picker
                              v-model="form.date"
                              :min="new Date().toISOString().substr(0, 10)"
                              @input="menu2 = false"
                            ></v-date-picker>
                          </v-menu> -->
                        </v-col>

                        <!-- <v-col cols="5">
                          <div class="fs-15 label-input">
                            Bukti
                          </div>
                          <v-radio-group
                            v-model="bukti"
                            row
                          >
                            <v-radio
                              label="Gambar"
                              value="gambar"
                            ></v-radio>
                            <v-radio
                              label="PDF"
                              value="pdf"
                            ></v-radio>
                          </v-radio-group>

                          <div v-if="bukti === 'gambar'">

                            <uploadfolder
                              v-model="upload.image_url" 
                              style="height: 350px; width: 350px;">
                              <div 
                                slot="activator"
                                class="cursor-pointer">
                                <v-card 
                                  flat
                                  height="350"
                                  class="d-flex align-center justify-center"
                                  style="border-radius: 15px;
                                        border: 2px solid #eaeaea; 
                                        border-style: dashed;">
                                  <div v-if="gambar_url.length < 1">
                                    <v-icon v-if="!process.image_url"
                                      size="60" 
                                      color="#4828a1">
                                      mdi-cloud-upload-outline
                                    </v-icon>
  
                                    <v-progress-circular v-else
                                      indeterminate
                                      :color="set_color">
                                    </v-progress-circular>
                                  </div>
  
                                  <v-img v-else
                                    contain
                                    height="350"
                                    :src="gambar_url" 
                                    :alt="gambar_url"
                                    class="text-center d-flex align-center">
                                    <div 
                                      class="d-flex aling-center justify-center" 
                                      style="width: 100%; height: auto;">
                                      <v-icon v-if="!process.image_url"
                                        size="60" 
                                        color="white">
                                        mdi-cloud-upload-outline
                                      </v-icon>
  
                                      <v-progress-circular v-else
                                        indeterminate
                                        :color="set_color">
                                      </v-progress-circular>
                                    </div>
                                  </v-img>
                                </v-card>
                              </div>
                            </uploadfolder>
                          </div>

                          <div v-if="bukti === 'pdf'">

                            <uploaddocument
                              v-model="upload.pdf_url" 
                              style="height: 350px; width: 350px;">
                              <div 
                                slot="activator"
                                class="cursor-pointer">
                                <v-card 
                                  flat
                                  height="350"
                                  class="d-flex align-center justify-center"
                                  style="border-radius: 15px;
                                        border: 2px solid #eaeaea; 
                                        border-style: dashed;">
                                  <div v-if="pdf_url.length < 1">
                                    <v-icon v-if="!process.pdf_url"
                                      size="60" 
                                      color="#4828a1">
                                      mdi-file-pdf-box
                                    </v-icon>
  
                                    <v-progress-circular v-else
                                      indeterminate
                                      :color="set_color">
                                    </v-progress-circular>
                                  </div>

                                  <div v-else>
                                    <iframe :src="pdf_url" height="350" frameborder="0"></iframe>
                                  </div>
  
                                </v-card>
                              </div>
                            </uploaddocument>
                          </div>

                          
                        </v-col> -->
                        
                      </v-row>

                    </v-form>
                  </ValidationObserver>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pt-0 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn 
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="190"
                height="45"
                elevation="0"
                color="#6948c6"
                class="fs-16 white--text text-capitalize border-radius">
                Simpan
              </v-btn>
              
              <v-btn
                to="/pengajuan/penerimaan/data"
                :disabled="process.form"
                color="red"
                elevation="0"
                width="140"
                height="45"
                class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                style="font-weight: 600;">
              
                  Batal
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: {
          
        },
        category: [
          {
            title: 'Parsial',
            id: 'Parsial'
          },
          {
            title: 'Full',
            id: 'Full'
          }
        ],
        modal: false,
        menu2: false,

        dialog: {
          customer: false,
          fullscreen: false
        },
        bukti: 'gambar',
        gambar_url: '',
        pdf_url: '',
        category: ['Gambar', 'Pdf'],
        pembelian: [],
        product_id: '',
        selected: [],
        headers: [],
        list: [],
        supplier: [],
        form: {
          po_id: '',
          // number: '',
          no_surat_jalan: '',
          // date: '',
          // bukti_url: '',
          varian_arr: []
        },
        headers_data: [],
        supervisor: [],
        branch: [],

        mobilephone: {
          name: '',
          id: ''
        },

        lastIndex: 1,

        upload: {
          pdf_url: null,
          image_url: null
        },

        process: {
          form: false,

          pdf_url: false,

          image_url: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
      uploaddocument: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/document.vue')
    },
    watch: {
      'upload.pdf_url': {
        handler: function () {
          if (this.upload.pdf_url) {
            this.process.pdf_url = this.upload.pdf_url.process

            if (!this.process.pdf_url) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.pdf_url = this.upload.pdf_url.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      },

      'upload.image_url': {
        handler: function () {
          if (this.upload.image_url) {
            this.process.image_url = this.upload.image_url.process

            if (!this.process.image_url) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.gambar_url = this.upload.image_url.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      configHeaders () {
          return this.headers_data.filter(header => !header.hide)  
        },
    },
    mounted () {
      // this.fetchVarian()
      this.fetchPembelian()
    },
    methods: {
      async fetchPembelian () {
        this.process.load = true

        let params = {
          limit: 1000000,
          status: 'terbit'
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/pembelian/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.pembelian = res.results.data
            
          }
          this.process.load = false
        })
      },
      changePembelian() {
        this.fetchDetail()
      },
      async fetchDetail () {
        let params = {
          id: this.form.po_id
        }

        await get('admin/pembelian/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.form.varian_arr = res.results.data.detail.map(item => {
              return {
                id: item.po_detail_varian_id,
                sku: item.po_detail_varian_sku,
                name: item.po_detail_varian_name,
                unit: item.po_detail_varian_unit,
                qty_po: item.po_detail_qty,
                qty: 0,
                qty_extra: 0,
                harga_beli: item.po_detail_harga_beli,
                ppn_beli: item.po_detail_ppn_beli,
                expired_date: '',
                penerimaan_qty_terima: item.penerimaan_qty_terima,
                penerimaan_qty_total: item.penerimaan_qty_total,
                penerimaan_qty_qc: item.penerimaan_qty_qc,
                total_in_dus: item.total_in_dus
              }
            })
            this.menu = res.results.data.detail.map(item => {
              return {
                menu: false
              }
            })
          }
          this.process.load = false
        })
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          let form = {
            ...this.form,
            bukti_url: this.bukti === 'gambar' ? this.gambar_url : this.pdf_url,
            varian_arr: JSON.stringify(this.form.varian_arr.map(item => {
              return {
                varian_id: item.id,
                varian_sku: item.sku,
                varian_name: item.name,
                varian_unit: item.unit,
                qty: item.unit === 'dus' ? item.qty * item.total_in_dus : item.unit === 'lusin' ? item.qty * 12 : item.qty,
                harga_beli: item.harga_beli,
                ppn_beli: item.ppn_beli,
                expired_date: item.expired_date,
                qty_extra: item.unit === 'dus' ? item.qty_extra * item.total_in_dus : item.unit === 'lusin' ? item.qty_extra * 12 : item.qty_extra,
              }
            })),
          }
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/penerimaan/add`, {
            data: form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.$router.push({ path: '/pengajuan/penerimaan/data' })

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>